import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _styled3 from "styled-components";
import _styled2 from "styled-components";
import _styled from "styled-components";
var _CloseSmall;
var _excluded = ["active", "label", "isDark", "data", "onClick", "onDelete", "disabled", "className", "content", "imageUrl", "css", "htmlProps"];
import cn from 'classnames';
import { css } from 'styled-components';
import { CloseSmall } from '@crehana/icons/outline';
import Avatar from "../Avatar";
import { CHIP_CONTAINER_STYLES, CHIP_DELETE_BUTTON_STYLES } from "./styles";
import { CHIP_THEMES } from "./themes";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Chip = function Chip(_ref) {
  var active = _ref.active,
    label = _ref.label,
    isDark = _ref.isDark,
    data = _ref.data,
    onClick = _ref.onClick,
    onDelete = _ref.onDelete,
    disabled = _ref.disabled,
    className = _ref.className,
    content = _ref.content,
    imageUrl = _ref.imageUrl,
    cssProp = _ref.css,
    htmlProps = _ref.htmlProps,
    props = _objectWithoutProperties(_ref, _excluded);
  var theme = isDark ? CHIP_THEMES.dark : CHIP_THEMES.light;
  var chipState = active ? 'active' : 'default';
  if (disabled) {
    chipState = 'disabled';
  }
  var themeVariables = theme[chipState];
  var handleClick = function handleClick() {
    if (onClick) {
      onClick(data);
    }
  };
  var wrapperClassNames = cn('px-12 py-8 font-body4 border border-solid inline-flex flex-shrink-0 items-center justify-center', className, themeVariables.borderColorClassname, themeVariables.backgroundColorClassname, themeVariables.fontColorClassname, !onDelete && [themeVariables.hoverBorderColorClassname, themeVariables.hoverFontColorClassname]);
  var wrapperCss = /*#__PURE__*/css(["\n    ", "\n    ", "\n  "], CHIP_CONTAINER_STYLES, cssProp);
  var avatar = imageUrl && /*#__PURE__*/_jsx(Avatar, {
    className: "mr-8",
    size: 20,
    src: imageUrl,
    isDark: isDark
  });
  if (onDelete) {
    return /*#__PURE__*/_jsxs(_StyledSpan, _objectSpread(_objectSpread(_objectSpread({
      className: cn(wrapperClassNames, 'cursor-default')
    }, htmlProps), props), {}, {
      $_css: wrapperCss,
      children: [avatar, label || content, !disabled && /*#__PURE__*/_jsx(_StyledButton, {
        type: "button",
        onClick: function onClick() {
          return onDelete(data);
        },
        className: cn('ml-8 block h-16 w-16 rounded-full', themeVariables.deleteIconColorClassname, themeVariables.deleteIconHoverColorClassname, themeVariables.deleteIconBackgroundHoverClassname),
        children: _CloseSmall || (_CloseSmall = /*#__PURE__*/_jsx(CloseSmall, {
          size: 16,
          className: "fill-current",
          ignoreColor: true
        }))
      })]
    }));
  }
  return /*#__PURE__*/_jsxs(_StyledButton2, _objectSpread(_objectSpread(_objectSpread({
    type: "button",
    onClick: handleClick,
    className: wrapperClassNames,
    disabled: disabled
  }, htmlProps), props), {}, {
    $_css2: wrapperCss,
    children: [avatar, label || content]
  }));
};
export default Chip;
var _StyledSpan = /*#__PURE__*/_styled("span").withConfig({
  componentId: "sc-hwzd65-0"
})(["", ""], function (p) {
  return p.$_css;
});
var _StyledButton = /*#__PURE__*/_styled("button").withConfig({
  componentId: "sc-hwzd65-1"
})(["", ""], CHIP_DELETE_BUTTON_STYLES);
var _StyledButton2 = /*#__PURE__*/_styled("button").withConfig({
  componentId: "sc-hwzd65-2"
})(["", ""], function (p) {
  return p.$_css2;
});